import React from 'react';
import {View} from 'react-native';
import {observer} from 'mobx-react';

import Text from '../../components/ui-controls/Text';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {useStores} from '../../stores/use-stores';

import RangeProductListScreen from './RangeProductListScreen';

const SubDepartmentScreen = observer(
  ({route}: RouteNavigatorScreenProps<AppRoute.SUB_DEPARTMENT>) => {
    const {rangeStore} = useStores();

    let {department} = route.params;
    let {subDepartment} = route.params;

    if (subDepartment?.id === 'view-all') {
      department = {
        ...department,
        name: 'View All',
      };
      rangeStore.selectDepartment(department);
      subDepartment = undefined;
    }

    rangeStore.selectDepartment(department);
    if (subDepartment) {
      rangeStore.selectSubDepartment(subDepartment);
    }

    if (!department || (department.name !== 'View All' && !subDepartment)) {
      return (
        <View>
          <Text>Category/SubCategory not found</Text>
        </View>
      );
    }

    // TODO: This depends on  rangeStore.selected... 🙄
    return <RangeProductListScreen />;
  },
);

export default SubDepartmentScreen;
